/**
 * Hero / Slideshow — Anabellé
 * Archivo: assets/hero-slideshow.js
 * Maneja autoplay, flechas, puntos y swipe táctil.
 * Se reinicializa automáticamente al editar en el Theme Editor.
 */
(function () {
  function initHeroSlideshow(root) {
    if (!root || root.dataset.heroInitialized === 'true') return;
    root.dataset.heroInitialized = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slide'));
    if (slides.length <= 1) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-goto]'));
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    var autoplay = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    var current = 0;
    var timer = null;

    function goTo(index) {
      var next = (index + slides.length) % slides.length;
      slides[current].classList.remove('is-active');
      slides[current].classList.add('is-prev');
      slides[next].classList.add('is-active');
      slides[next].classList.remove('is-prev');

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === next);
      });

      window.setTimeout(function () {
        slides.forEach(function (slide, i) {
          if (i !== next) slide.classList.remove('is-prev');
        });
      }, 650);

      current = next;
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = window.setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-hero-goto'), 10));
        startAutoplay();
      });
    });

    // Swipe táctil básico
    var touchStartX = 0;
    root.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      var touchEndX = e.changedTouches[0].screenX;
      var delta = touchEndX - touchStartX;
      if (Math.abs(delta) > 40) {
        if (delta < 0) next(); else prev();
        startAutoplay();
      }
    }, { passive: true });

    // Pausar autoplay si el mouse está sobre el banner
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-hero-slideshow]').forEach(initHeroSlideshow);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // Soporte para el Theme Editor de Shopify (drag & drop, edición en vivo)
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-hero-slideshow]');
    if (root) {
      root.dataset.heroInitialized = 'false';
      initHeroSlideshow(root);
    }
  });
})();